import React from 'react';

import Auth from './Auth';
import Language from './Language';

const App = ({ children }) => (
  <Auth>
    <Language>{children}</Language>
  </Auth>
);

const withAppProvider = Component => props => (
  <App>
    <Component {...props} />
  </App>
);

export default withAppProvider;



// WEBPACK FOOTER //
// /app/apps/ms/src/providers/App.js